import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';
import { FaCheckCircle } from 'react-icons/fa';

const EmptyContainer = styled.div`
  text-align: center;
  padding: 64px 24px;
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

const EmptyIcon = styled.div`
  font-size: 64px;
  color: #2e7d32;
  margin-bottom: 16px;
  opacity: 0.6;
`;

const EmptyTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a2c3e;
  margin-bottom: 8px;
`;

const EmptyMessage = styled.p`
  color: #5a6e7c;
  max-width: 400px;
  margin: 0 auto;
`;

const EmptyPendencias = () => {
  return (
    <EmptyContainer>
      <EmptyIcon>
        <FaCheckCircle />
      </EmptyIcon>
      <EmptyTitle>Nenhuma pendência encontrada</EmptyTitle>
      <EmptyMessage>
        Você não possui nenhum documento indeferido pendente de reenvio no momento.
      </EmptyMessage>
    </EmptyContainer>
  );
};

export default EmptyPendencias;
